import React from "react";
import { Wrapper } from "./style";
import CreateCom1 from "./components/CreateCom1";
import CreateCom4 from "./components/CreateCom4";
import CreateCom3 from "./components/CreateCom3";
import CreateCom2 from "./components/CreateCom2";
import { useTranslation } from "react-i18next";
const CreateWallet = () => {
  const { t } = useTranslation("usingWallet");
  return (
    <Wrapper>
      <CreateCom1 t={t} />
      <CreateCom2 t={t} />
      <CreateCom3 t={t} />
      <CreateCom4 t={t} />
    </Wrapper>
  );
};

export default CreateWallet;
